<template>
  <div v-if="isLoaded">
    <transition>
      <div class="row" v-if="unitsErrorMessage">
        <div class="col-12">
          <div style="
                color: #e65252;
                font-size: 16px;
                padding: 10px;
                background: #F8F8F8;
                border: 1px solid #e65252;
                margin-bottom: 20px;
                border-radius: 3px">
            {{ unitsErrorMessage }}
          </div>
        </div>
      </div>
    </transition>

    <div v-if="showUpdateAsAdminButton" class="row mb-5" style="border-bottom: 1px solid #D8D8D8">
      <div class="col text-end" style="font-size: 17px;">{{ $t('general.update_as_admin') }}</div>
      <div class="col-auto text-end">
        <BaseToggle v-model="updateAsAdmin" @change="onChangeUpdateAsAdmin"/>
      </div>
    </div>

    <form @submit.prevent="submitForm" novalidate>
      <div class="row">
        <div class="col-lg-2 col-md-4 col-sm-6 col-12  ">
          <Datepicker
              v-model="formData.termin"
              @update:modelValue="onUpdateTerminGetCoachingAppointmentsDropdown"
              :disabled="isBilled || isCoachBilled || haveParentMeetingId"
              :required="true"
              label="Termin"
              position="down"
              :validation="v$.termin"
              :messages="v$.termin.required.$message"/>
        </div>
        <div class="col-lg-4 col-md-8 col-sm-12  ">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <Timepicker
                  v-model="formData.startTime"
                  :key="startTimeKey"
                  :disabled="isBilled || isCoachBilled || haveParentMeetingId"
                  :required="true"
                  :minutesArray=minutesArray
                  label="Startzeit"/>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12">
              <Timepicker
                  v-model="formData.endTime"
                  :key="endTimeKey"
                  :disabled="isBilled || isCoachBilled || haveParentMeetingId"
                  :required="true"
                  :minutesArray=minutesArray
                  label="Endzeit"/>
            </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <SelectVue v-model="formData.presence"
                     :disabled="isBilled || isCoachBilled || haveParentMeetingId"
                     :options="presenceDropdown"
                     :required="true"
                     :is-clear="true"
                     label="Anwesenheit"
                     placeholder="Wählen Sie Anwesenheit"
                     :validation="v$.presence"
                     :messages="v$.presence.required.$message"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <BaseNumber
              v-model="formData.units"
              :labelStyle="labelStyle"
              label="Fachleistungsstunden"
              disabled="disabled"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12">
          <BaseNumber
              v-model="formData.totalMinutes"
              :labelStyle="labelStyle"
              label="in Minuten"
              disabled="disabled"/>
        </div>

        <div class="col-lg-2 col-md-4 col-sm-12 mt-3">
          <BaseCheckbox
              v-model="formData.signature"
              :disabled="isBilled || isCoachBilled || isDigitalSignature || haveParentMeetingId"
              :validation="v$.signature"
              label="Unterschrift"
              :labelPosition="'right'"/>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-12 mt-3"
             v-if="currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT'">
          <BaseCheckbox
              v-model="formData.billed"
              :disabled="isBilled || haveParentMeetingId"
              :validation="v$.billed"
              label="Abgerechnet"
              :labelPosition="'right'"/>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <SelectVue
              v-model="formData.placeAndTypeOfCare"
              :options="placeAndTypeOfCareDropdown"
              :disabled="isBilled || isCoachBilled || haveParentMeetingId"
              :required="true"
              label="Ort und art der betreuung"
              :validation="v$.placeAndTypeOfCare"
              :messages="v$.placeAndTypeOfCare.required.$message"/>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12"
             v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT'">
          <SelectVue
              v-model="formData.coachId"
              :disabled="isCoachBilled || haveParentMeetingId"
              :options="coachDropdown"
              :is-clear="true"
              label="Coach"
              placeholder="Trainer auswählen"/>
        </div>
      </div>

      <div class="row mt-3 pt-3" style="border-top: 1px solid #ddd">
        <div class="col-lg-4 col-md-12 col-sm-12">
          <SelectVue
              v-model="formData.appointmentType"
              @update:modelValue="onUpdateAppointmentType"
              :options="appointmentTypeDropdown"
              :disabled="isBilled || isCoachBilled || haveParentMeetingId"
              :required="true"
              :is-clear="false"
              label="Art des Termins"
              :validation="v$.appointmentType"
              :messages="v$.appointmentType?.required?.$message"/>
        </div>
      </div>

      <div class="row" v-if="showGroupAppointment && !haveParentMeetingId">
        <div class="col-12">
          <p style="margin-bottom: 5px; color: red;" v-if="!formData.termin">Bitte wählen Sie Termin aus</p>
          <div v-for="(appointment, index) in formData.groupAppointments" :key="index" class="mb-2">
            <div class="row">
              <div class="col-lg-5 col-md-12 col-sm-12">
                <SelectVue
                    v-model="appointment.coachingId"
                    @update:modelValue="calculateTimeDifference"
                    :options="appointmentCoachingDropdown"
                    :is-clear="true"
                    :required="true"
                    placeholder="Wählen Sie Maßnahmenn"
                    :validation="v$.groupAppointments?.$each?.$response?.$data[index]?.coachingId"
                    :messages="v$.groupAppointments?.$each?.$response?.$errors[index]?.coachingId[0]?.$message"/>
              </div>

              <div class="col-lg-3 col-md-12 col-sm-12">
                <SelectVue
                    v-model="appointment.coachId"
                    @update:modelValue="onUpdateAppointmentCoachDropdown"
                    :options="appointmentCoachDropdown"
                    :is-clear="true"
                    :required="true"
                    placeholder="Wählen Sie Coach"
                    :validation="v$.groupAppointments?.$each?.$response?.$data[index]?.coachId"
                    :messages="v$.groupAppointments?.$each?.$response?.$errors[index]?.coachId[0]?.$message"/>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-12">
                <SelectVue
                    v-model="appointment.coachType"
                    :options="coachTypeDropdown"
                    :is-clear="true"
                    :required="true"
                    placeholder="Wählen Sie Coach-Typ"
                    :validation="v$.groupAppointments?.$each?.$response?.$data[index]?.coachType"
                    :messages="v$.groupAppointments?.$each?.$response?.$errors[index]?.coachType[0]?.$message"/>
              </div>
              <div class="col-lg-1 col-md-1 col-sm-12">
                <button class="btn btn-danger ms-2 mb-3" @click.prevent="deleteGroupAppointment(index)">
                  <i class="os-icon os-icon-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 text-end">
          <button type="button" class="btn btn-primary" @click="addGroupAppointment">Coach hinzufügen</button>
        </div>
      </div>

      <div class="row mt-4 pt-3" style="border-top: 1px solid #ddd">
        <div class="col-12">
          <h6>Einschränkung</h6>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <BaseInput
              v-model="formData.meetingTopic"
              label="Zusammenfassende Dokumentation für LWL (Differenzierung FK-Doku/AK-Doku"
              :required="true"
              :validation="v$.meetingTopic"
              :messages="v$.meetingTopic.required.$message"/>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12">
          <TextEditor
              v-model="formData.description"
              @update:model-value="formData.description = $event"
              :inputStyle="{ height: '200px' }"
              label="Beschreibung"/>
        </div>
      </div>

      <div v-if="!unitsErrorMessage" class="d-flex justify-content-center w-100 mt-5">
        <SaveButton
            :label="$t('general.button.save')"
            :loading="isSubmitting"/>
      </div>
    </form>
  </div>
</template>

<script setup>
import dropdownService from '@/api/Dropdown';
import portalCoachingService from '@/api/Portal/AssistedLivingCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import Timepicker from '@/components/picker/Timepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import TextEditor from '@/components/TextEditor.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {generatePlaceAndTypeOfCareDropdown} from '@/shared/portal/assistedLivingCoachingFunctions';
import {addDeletedCoachToDropdown} from '@/shared/portal/commonFunctions';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import useVuelidate from '@vuelidate/core';
import {computed, defineEmits, defineProps, onMounted, ref, toRefs, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {helpers} from "@vuelidate/validators";
import {getUsersForAssistedLivingCoachingDropdown} from "@/shared/dropdowns";
import BaseToggle from "@/components/base/BaseToggle.vue";
import SaveButton from '@/components/button/SaveButton.vue';

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const currentUserRole = piniaCurrentUser.value.roles[0];
const piniaEnumsState = piniaEnumsStore();
const getEnums = computed(() => piniaEnumsState.enums);
const {t} = useI18n();
const coachDropdown = ref([]);
const presenceDropdown = ref([]);
const unitsErrorMessage = ref('');
const isLoaded = ref(false);
const isSubmitting = ref(false);
const isBilled = ref(false);
const isCoachBilled = ref(false);
const haveParentMeetingId = ref(false);
const placeAndTypeOfCareDropdown = ref([]);
const appointmentTypeDropdown = ref([]);
const showGroupAppointment = ref(false);
const appointmentCoachingDropdown = ref([]);
const appointmentCoachDropdown = ref([]);

const updateAsAdmin = ref(false) // Need this for update as admin logic
const originalIsBilled = ref(false); // Need this for update as admin logic
const originalIsCoachBilled = ref(false); // Need this for update as admin logic

const emit = defineEmits(['update:modelValue', 'update:submitForm']);


const coachTypeDropdown = [
  {
    value: 'specialist',
    label: 'Fachkraft',
  },
  {
    value: 'supervisor',
    label: 'Assistenzkraft',
  },
];

const props = defineProps({
  coachingId: {
    type: Number,
    required: true,
  },
  locationId: {
    type: Number,
    required: true,
  },
  protocolId: {
    type: Number,
    required: true,
  },
  operationType: {
    type: String,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
  isDigitalSignature: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const coachingId = toRefs(props)['coachingId'];
const locationId = toRefs(props)['locationId'];
const protocolId = toRefs(props)['protocolId'];
const operationType = toRefs(props)['operationType'];

const formData = ref({
  coachingId: '',
  operationType: '',
  termin: '',
  startTime: '00:00',
  endTime: '00:00',
  presence: '',
  units: 0.0,
  totalMinutes: 0,
  signature: false,
  billed: false,
  coachId: null,
  meetingTopic: '',
  description: '',
  placeAndTypeOfCare: '',
  appointmentType: '',
  groupAppointments: [],
});

const originalFormData = ref({});
// This key will force the Timepicker to re-create when changed
const startTimeKey = ref(formData.value.startTime);
const endTimeKey = ref(formData.value.endTime);

const formRules = ref({
  termin: requiredRule(t),
  startTime: requiredRule(t),
  endTime: requiredRule(t),
  presence: requiredRule(t),
  units: requiredRule(t),
  totalMinutes: requiredRule(t),
  meetingTopic: requiredRule(t),
  placeAndTypeOfCare: requiredRule(t),
  appointmentType: requiredRule(t),
  groupAppointments: {
    $each: helpers.forEach({
      coachingId: requiredRule(t),
      coachId: requiredRule(t),
      coachType: requiredRule(t),
    }),
  },
});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId.value;
    formData.value.operationType = operationType.value;
    formData.value.units = Number(formData.value.units);// or parseFloat if you prefer
    formData.value.totalMinutes = Number(formData.value.totalMinutes);

    if (props.protocolId) {
      if (updateAsAdmin.value) {
        await portalCoachingService.updateProtocolAsAdmin(
            formData.value,
            +protocolId.value
        );
      } else {
        await portalCoachingService.updateProtocol(
            formData.value,
            +protocolId.value
        );
      }
    } else {
      await portalCoachingService.postProtocol(formData.value);
    }

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getProtocolData(protocolId) {
  try {
    const {data} = await portalCoachingService.getProtocol(protocolId.value);
    const coachId = data.data?.coach?.id;
    const groupAppointments = data.data?.groupAppointments ?? [];

    isBilled.value = data.data.invoiced;
    isCoachBilled.value = data.data.coachInvoiced;

    // Save original values
    originalIsBilled.value = data.data.invoiced;
    originalIsCoachBilled.value = data.data.coachInvoiced;

    const parentMeetingId = data.data.parentMeetingId;

    if (parentMeetingId && parentMeetingId !== '') {
      haveParentMeetingId.value = true
    }

    addDeletedCoachToDropdown(data.data?.coach, coachDropdown);

    formData.value = {
      ...data.data,
      coachId: coachId
    };

    formData.value.groupAppointments = []; // Clear before fill

    groupAppointments.forEach(app => {
      formData.value.groupAppointments.push({
        coachingId: app.coachingId ?? '',
        coachingName: app.coachingName ?? '',
        coachId: app.coachId ?? '',
        coachType: app.coachType ?? '',
        protocolId: app.protocolId ?? '',
      });
    });

    // store original as a deep copy !!!
    originalFormData.value = JSON.parse(JSON.stringify(formData.value));

  } catch (error) {
    await ErrorToast(error);
  }
}

async function getAssignedCoaches(coachingId) {
  try {
    CloseToast();
    const {data} = await dropdownService.getAssistedLivingCoachingAssignedCoaches(+coachingId);
    coachDropdown.value = data.data.map(item => ({
      label: `${item.firstName}` + ' ' + `${item.lastName}`,
      value: item?.id,
    }));
  } catch (error) {
    await ErrorToast(error);
  }
}

const calculateTimeDifference = () => {

  if (formData.value.startTime && formData.value.endTime) {
    const [startHours, startMinutes] = formData.value.startTime.split(':').map(Number);
    const [endHours, endMinutes] = formData.value.endTime.split(':').map(Number);
    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    // Group child has no groupAppointments list (only parent has it) - use numberOfClients saved on backend
    const countGroupAppointments = haveParentMeetingId.value && formData.value.numberOfClients > 0
        ? formData.value.numberOfClients
        : formData.value.groupAppointments?.length + 1;


    let diffMinutes;
    if (countGroupAppointments > 0) {
      diffMinutes = (endTotalMinutes - startTotalMinutes) / (countGroupAppointments);
    } else {
      diffMinutes = endTotalMinutes - startTotalMinutes;
    }

    const unitDuration = 50;
    let units = (diffMinutes / unitDuration).toPrecision(3).substring(0, 4);

    onChangeUnits(units);

    // if (units > 0) {
    //   if (diffMinutes % 10 === 0) {
    //     unitsErrorMessage.value = '';
    //   } else {
    //     unitsErrorMessage.value = 'Abrechnung nur in 10-Minuten-Blöcken möglich.';
    //   }
    // }

    formData.value.units = Number(units).toFixed(2);
    formData.value.totalMinutes = Number(diffMinutes).toFixed(2);
  } else {
    formData.value.units = 0;
    formData.value.totalMinutes = 0;
  }
};

function onChangeUnits(value) {
  const parsedValue = parseFloat(value);

  if (isNaN(parsedValue) || parsedValue <= 0) {
    unitsErrorMessage.value = 'Einheiten müssen runde Zahlen sein, die größer als 0 sind.';
  } else {
    unitsErrorMessage.value = '';
  }
}

watch(
    () => [
      formData.value.startTime,
      formData.value.endTime,
      formData.value.presence,
    ],
    calculateTimeDifference,
);

async function getEnumsDropdown() {
  presenceDropdown.value = (getEnums?.value?.presenceTypes || []).filter(
      type => type.value === 'anwesend' || type.value === 'unentschuldigt',
  );
  appointmentTypeDropdown.value = getEnums.value.assistedLivingCoachingAppointmentTypes
}

const labelStyle = computed(() => {
  return unitsErrorMessage.value ? {color: 'red'} : {};
});


// Group appointment
function onUpdateAppointmentType(value) {
  if (value === 'group') {
    showGroupAppointment.value = true
  } else {
    formData.value.groupAppointments = []
    showGroupAppointment.value = false
  }
}

// function getCoachDropdownValueByIndex(index) {
//   if (index) {
//     return appointmentCoachDropdown.value[index];
//   } else {
//     return [];
//   }
// }

function onUpdateAppointmentCoachDropdown(value) {
  // console.log(value);
}

async function addGroupAppointment() {
  formData.value.groupAppointments.push({
    coachingId: '',
    protocolId: '',
    coachId: '',
    coachType: '',
    coachFullName: ''
  });
  v$.value.$touch();
}

async function deleteGroupAppointment(index) {
  formData.value.groupAppointments.splice(index, 1);
  calculateTimeDifference()
}

async function onUpdateTerminGetCoachingAppointmentsDropdown(newTermin, onMounted = false) {
  try {
    if (!onMounted) {
      formData.value.groupAppointments = [];
    }

    if (newTermin && isValidDateFormat(newTermin)) {
      const {data} = await dropdownService.getNewAndActiveAssistedLivingCoaching(newTermin, coachingId.value);
      appointmentCoachingDropdown.value = data?.data?.coachingData;
    } else {
      appointmentCoachingDropdown.value = [];
    }
  } catch (error) {
    await ErrorToast(error);
  }
}

function isValidDateFormat(date) {
  return /^\d{2}\.\d{2}\.\d{4}$/.test(date);
}


function addCoachToDropdown(coachId, appointmentCoachDropdown) {
  const exists = appointmentCoachDropdown.value.some(item => item.value === coachId);
  if (!exists) {


    // appointmentCoachDropdown.value.push(coach);
  }

  // const coach  = {
  //   label: "Pero Peric",
  //   value: coachId,
  // };

}

function onChangeUpdateAsAdmin() {
  if (updateAsAdmin.value) {
    isBilled.value = false;
    isCoachBilled.value = false;
  } else {
    // restore form data from original snapshot
    formData.value = JSON.parse(JSON.stringify(originalFormData.value));

    formData.value.startTime = originalFormData.value.startTime;
    startTimeKey.value = originalFormData.value.startTime + '_' + Date.now(); // Change the key to force re-render

    formData.value.endTime = originalFormData.value.endTime;
    endTimeKey.value = originalFormData.value.endTime + '_' + Date.now(); // Change the key to force re-render

    isBilled.value = originalIsBilled.value;
    isCoachBilled.value = originalIsCoachBilled.value;
  }
}

const showUpdateAsAdminButton = computed(() =>
    (currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') &&
    (originalIsBilled.value || originalIsCoachBilled.value)
);

const minutesArray = [
  '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11',
  '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23',
  '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35',
  '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47',
  '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59',
];

onMounted(async () => {
  await Promise.all([
    getAssignedCoaches(+coachingId.value),
    getEnumsDropdown(),
    placeAndTypeOfCareDropdown.value = generatePlaceAndTypeOfCareDropdown(),
    getUsersForAssistedLivingCoachingDropdown(appointmentCoachDropdown, locationId.value)
  ]);

  if (protocolId.value) {
    await getProtocolData(protocolId);
    await onUpdateTerminGetCoachingAppointmentsDropdown(formData.value.termin, true)
    onUpdateAppointmentType(formData.value.appointmentType)
    addCoachToDropdown(859, appointmentCoachDropdown)
  }

  isLoaded.value = true;
});
</script>
<style scoped>

</style>